import * as React from "react";
import { useLoadAllDevicesQuery } from "../../store";
import { MenuItem, Button, Menu, ButtonGroup } from "@mui/material";
import { Device } from "../../store/apis/devicesApi";
import {useEffect, useState} from "react";

export const RenderSelectDeviceButton = ({
  setSelectedDevice
}: {
  setSelectedDevice: (dev: Device) => void;
}) => {
  const { data } = useLoadAllDevicesQuery(null);
  const [selected, setSelected] = useState<string>();

  useEffect(() => {
    if (data?.length){
      setSelectedDevice(data[0]);
      setSelected(data[0].deviceId);
    }
  }, [data]);

  if (!data || !data.length) return <div />;

  const handleClick = (device: Device) => {
    setSelectedDevice(device);
    setSelected(device.deviceId);
  }

  const renderItems = () => {
    return data.map(device => (
      <Button key={device.deviceId} onClick={() => handleClick(device)} variant={ device.deviceId === selected ? "contained" : "outlined"}>
        {device.location}
      </Button>
    ));
  };

  return (
      <ButtonGroup fullWidth={true} orientation={"vertical"} aria-label="Select sensor">
        {renderItems()}
      </ButtonGroup>
  );
};
